import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Modal from '../components/Modal';
import toast from 'react-hot-toast';
import { Plus, Trash2 } from 'lucide-react';
import { formatCurrency, formatDate, today } from '../utils/helpers';

const empty = { vehicle_id:'', maintenance_date:today(), maintenance_type:'service', description:'', odometer_reading:'', service_center:'', cost:0, next_service_date:'', next_service_km:'', invoice_no:'' };

export default function Maintenance() {
  const [list, setList] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);

  const load = () => api.get('/maintenance').then(r => setList(r.data.data || []));
  useEffect(() => {
    load();
    api.get('/vehicles').then(r => setVehicles(r.data.data || []));
  }, []);

  const save = async () => {
    if (!form.vehicle_id) return toast.error('Vehicle required');
    try { await api.post('/maintenance', form); toast.success('Logged'); setOpen(false); setForm(empty); load(); }
    catch (e) { toast.error(e?.response?.data?.message || 'Error'); }
  };
  const del = async (id) => { if (!window.confirm('Delete?')) return; try { await api.delete('/maintenance/' + id); toast.success('Deleted'); load(); } catch (e) { toast.error('Error'); } };

  const total = list.reduce((s, r) => s + parseFloat(r.cost || 0), 0);

  return (
    <div className="card">
      <div className="card-header">
        <h3>Vehicle Maintenance ({list.length}) — Total: {formatCurrency(total)}</h3>
        <button className="btn btn-blue" onClick={() => { setForm(empty); setOpen(true); }}><Plus size={14}/> Log Maintenance</button>
      </div>
      <div className="table-wrap">
        <table>
          <thead><tr><th>Date</th><th>Vehicle</th><th>Type</th><th>Description</th><th>Service Center</th><th>Odometer</th><th className="td-num">Cost</th><th>Next Service</th><th>Actions</th></tr></thead>
          <tbody>
            {list.length ? list.map(m => (
              <tr key={m.id}>
                <td>{formatDate(m.maintenance_date)}</td>
                <td><strong>{m.vehicle_no}</strong></td>
                <td><span className="badge badge-blue">{m.maintenance_type}</span></td>
                <td>{m.description || '-'}</td>
                <td>{m.service_center || '-'}</td>
                <td>{m.odometer_reading || '-'}</td>
                <td className="td-num">{formatCurrency(m.cost)}</td>
                <td>{formatDate(m.next_service_date)}</td>
                <td><button className="btn btn-sm btn-red" onClick={()=>del(m.id)}><Trash2 size={12}/></button></td>
              </tr>
            )) : <tr><td colSpan="9" className="empty">No maintenance records</td></tr>}
          </tbody>
        </table>
      </div>

      <Modal open={open} onClose={()=>setOpen(false)} title="Log Maintenance" size="lg"
        footer={<>
          <button className="btn btn-gray" onClick={()=>setOpen(false)}>Cancel</button>
          <button className="btn btn-blue" onClick={save}>Save</button>
        </>}>
        <div className="form-grid">
          <div className="form-group"><label>Vehicle *</label>
            <select value={form.vehicle_id} onChange={e=>setForm({...form, vehicle_id:e.target.value})}>
              <option value="">-- Select Vehicle --</option>
              {vehicles.map(v=><option key={v.id} value={v.id}>{v.vehicle_no} — {v.driver_name||'No driver'}</option>)}
            </select>
          </div>
          <div className="form-group"><label>Date *</label><input type="date" value={form.maintenance_date} onChange={e=>setForm({...form, maintenance_date:e.target.value})}/></div>
          <div className="form-group"><label>Type</label>
            <select value={form.maintenance_type} onChange={e=>setForm({...form, maintenance_type:e.target.value})}>
              <option value="service">Service</option><option value="repair">Repair</option><option value="tyre">Tyre</option>
              <option value="battery">Battery</option><option value="oil_change">Oil Change</option>
              <option value="insurance">Insurance</option><option value="permit">Permit</option><option value="other">Other</option>
            </select>
          </div>
          <div className="form-group"><label>Odometer (KM)</label><input type="number" value={form.odometer_reading} onChange={e=>setForm({...form, odometer_reading:e.target.value})}/></div>
          <div className="form-group"><label>Service Center</label><input value={form.service_center} onChange={e=>setForm({...form, service_center:e.target.value})}/></div>
          <div className="form-group"><label>Invoice No</label><input value={form.invoice_no} onChange={e=>setForm({...form, invoice_no:e.target.value})}/></div>
          <div className="form-group"><label>Cost *</label><input type="number" value={form.cost} onChange={e=>setForm({...form, cost:e.target.value})}/></div>
          <div className="form-group"><label>Next Service Date</label><input type="date" value={form.next_service_date} onChange={e=>setForm({...form, next_service_date:e.target.value})}/></div>
          <div className="form-group"><label>Next Service KM</label><input type="number" value={form.next_service_km} onChange={e=>setForm({...form, next_service_km:e.target.value})}/></div>
          <div className="form-group full-width"><label>Description / Work Done</label><textarea value={form.description} onChange={e=>setForm({...form, description:e.target.value})}/></div>
        </div>
      </Modal>
    </div>
  );
}
